import { render } from "./IceCalendar.vue?vue&type=template&id=2021a146&scoped=true"
import script from "./IceCalendar.vue?vue&type=script&lang=js"
export * from "./IceCalendar.vue?vue&type=script&lang=js"

import "./IceCalendar.vue?vue&type=style&index=0&id=2021a146&lang=scss&scoped=true"

import exportComponent from "/Users/icesea/WebstormProjects/fpcs-h5/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2021a146"]])

export default __exports__